// @flow
import window from 'window';
import Q from 'q';
import _ from 'lodash';
import ko from 'rgs-knockout';
import keycode from 'keycode';
import type { Observable } from 'rgs-knockout';

export interface MenuListOptions {
	expanded: Observable<boolean>;
	initialStyles: {};
	animationStyles: {};
	delay: number;
	title: string;
}

export default class MenuListModel {
	constructor (options: MenuListOptions, ref: HTMLDivElement) {

		this._options = _.defaults(options, {
			title: 'Действия',
			expanded: ko.observable(false),
			initialStyles: {
				'right': 0,
				'max-height': 0,
				'overflow': 'hidden',
				'position': 'absolute',
				...(options.initialStyles || {}),
			},
			animationStyles: {
				'transition': 'max-height 2s ease-out',
				'max-height': '200vh',
				...(options.animationStyles || {}),
			},
			delay: 2000,
		});

		this.title = this._options.title;

		this._ref = ref && ref.element;

		this._expanded = ko.map(this._options.expanded, {
			mapWrite: (v: boolean) => v ? this.subscribe() : this.dispose(),
		});

		this._menuStyle = ko.observable({});
	}

	_onClick () {
		this._expanded(!this._expanded());
	}

	_afterRender = () => {
		return Q(this._menuStyle(this._options.initialStyles))
			.then(() => this._menuStyle(this._options.animationStyles))
			.then(() => Q.delay(this._options.delay))
			.then(() => this._menuStyle({
				'overflow': 'initial',
			}))
			.done();
	}

	_outerClickHandler = ({ target }: { target: Node }): void => {
		if (this._expanded.peek() && !this._ref.contains(target)) {
			this._expanded(false);
		}
	};

	_keysEventHandler = (e: KeyboardEvent<HTMLDivElement>) => {
		if (e.which === keycode('escape') || e.which === keycode('enter')) {
			this._expanded(false);
		}

		return true; // must be!
	}

	dispose (): void {
		window.removeEventListener('click', this._outerClickHandler, true);
		window.removeEventListener('keydown', this._keysEventHandler);
		return false;
	}

	subscribe () {
		window.addEventListener('click', this._outerClickHandler, true);
		window.addEventListener('keydown', this._keysEventHandler);
		return true;
	}
}